export default {
  account_existed: " Ang pangalan ng tagagamit ay hindi magagamit.",
  account_not_exists: " Ang pangalan ng tagagamit ay hindi umiiral.",

  invalid_password: "Hindi wastong Password!",
  insufficient_balance: "Kulang na pondo!",

  // verify_failed: "Mali ang numero ng veripikasyon.",

  withdrawalAmountMustGreaterThan0: "Ang halagang ibiwithdraw ay dapat higit sa 0.",
  block: "Ang iyong account ay pansamantalang itinigil.",

  requestTooFrequentAtLeast2Minutes: "Ang request ay masyadong madalas. Pakisubukang muli pagkatapos ng 2 minuto.",

  invalidPasswordFormat:"Lumikha ng iyong sariling password. Ang password ay dapat na may 6-20 na titik at numero.",
  isRequired: "Mangyaring punan ang {fname}.",
  isMinValue: "Ang {fname} ay dapat may hindi bababa sa {fvalue}.",
  isMaxValue: "Ang {fname} ay dapat mababa o pantay sa {fvalue}.",
  isMinLength: "Ang {fname} ay dapat may hindi bababa sa {fvalue} na mga titik.",
  isMaxLength: "Ang {fname} ay dapat mababa o pantay sa {fvalue} na mga titik.",
  isAlpha: "Ang {fname} ay tumatanggap lamang ng mga letra.",
  isAlphaNum: "Ang {fname} ay tumatanggap lamang ng mga letra at numero.",
  isNumeric: "Ang {fname} ay tumatanggap lamang ng mga numero.",
  isEmail: "Mangyaring maglagay ng wastong email address.",
  isIpAddress: "Ang {fname} ay tumatanggap lamang ng wastong mga IPv4 address.",
  isSameAs: "Ang {fname} ay dapat pareho sa {fname2}.",
  isUrl: "Ang {fname} ay tumatanggap lamang ng mga URL.",
  containAlphaNum: "Ang {fname} ay dapat may hindi bababa sa isang letra at isang numero.",
  selectOption: "Mangyaring pumili ng {fname}.",
  notSameAs: "Ang {fname} at {fname2} ay hindi maaaring pareho.",
  isBetween: "Ang {fname} ay dapat nasa pagitan ng {min} at {max}.",
  checkFormat: "Mangyaring punan ang numero ng telepono ng tatanggap sa sumusunod na format.",
  invalid_referral_code: "Hindi wastong Referral Code.",
  accountIdOnlyNumber: "Tanging mga numero lamang ang pinapayagan.",
  passwordStrengthError: "Likha ng sarili mong password. Dapat itong may 6-20 na karakter at isang kombinasyon ng numero at letra",
  tacCodeRequired: "Kinakailangan ang OTP Code.",
  invalid_tac: "Hindi wastong OTP Code.",
  tac_is_valid: "Ang OTP Code ay naipadala sa iyong numero ng kontakto.",
  loginFailed: "Nabigo sa pag-login.",
  loginSucceed: "Matagumpay na nag-login.",
  usernameRequired : "Mangyaring maglagay ng pangalan ng tagagamit.",
  passwordRequired : "Mangyaring maglagay ng password.",
  logoutSucceed : "Matagumpay na nag-logout.",
  logoutFailed : "Nabigo sa pag-logout.",
  requestSucceed: "Tagumpay ang request.",
  requestFailed : "Nabigo ang request.",
  requestProcessing : "Kasalukuyang ini-process ang iyong request.",
  requestDelayed: "Pag-antala sa request.",
  verificationCodeRequired: "Kinakailangan ang OTP Code para sa veripikasyon.",
  newPasswordRequired: "Kinakailangan ang Bagong Password.",
  bankIdRequired: "Mangyaring pumili ng bangko.",
  bankNameRequired: "Kinakailangan ang Pangalan ng Bangko.",
  bankAccHolderRequired : "Kinakailangan ang Pangalan ng may-ari ng Bankong Account.",
  bankAccNoRequired: "Kinakailangan ang Numero ng Bankong Account.",
  walletIdRequired: "Pumili ng e-wallet",
  walletHolderRequired: "Kinakailangan ang pangalan ng may-ari ng E-Wallet",
  walletNoRequired: "Kinakailangan ang numero ng E-Wallet",
  depositAmountRequired: "Mangyaring maglagay ng halaga ng deposito.",
  dateRequired: "Mangyaring pumili ng petsa.",
  bonusIdRequired: "Mangyaring pumili ng regalo na igi-claim.",
  session_expired : 'Nag-expire na ang sesyon.',
  account_inactive: "Ang pangalan ng tagagamit/Account ay hindi aktibo.",
  account_exists: "User/Account ID has already existed",
  OK: "Matagumpay na naipadala ang OTP.", // for OTP
  ok: "Matagumpay na naipadala ang OTP.", // for OTP
  CLOSE: "Ang iyong account ay pansamantalang na-block dahil sa paglabag sa Fair Gaming Terms ng EpicWin",
  close: "Ang iyong account ay pansamantalang na-block dahil sa paglabag sa Fair Gaming Terms ng EpicWin",
  accountIdRequired: 'Kinakailangan ang ID ng Tagagamit/Account.',

  app_id_required: "Application ID is required",
  permission_denied: "Hindi pinapahintulutan",
  account_id_required: "Kinakailangan ang Username/Account ID",
  verification_code_required: "Kinakailangan ang verification code",
  account_inactive: "Ang Username/Account ay hindi aktibo",
  verify_failed: "Nabigo ang proseso ng pag-verify",
  parent_account_inactive: "Parent account is inactive",
  transfer_id_required: "Transfer ID is required",
  credit_amount_required: "Kinakailangan ang halagang kredito",
  duplicate_credit_record: "Doble na ang talaan ng kredito",
  member_wallet_not_exists: "Walang umiiral na pitaka ng miyembro",
  debit_amount_required: "Debit amount is required",
  duplicate_debit_record: "Duplicated debit record",
  result_exists: "May umiiral na talaan ng resulta",
  debit_record_not_found: "Debit record is not found",
  bank_id_required: "Kinakailangan ang ID ng bangko",
  bank_acc_no_required: "Kinakailangan ang numero ng bankong account",
  bank_acc_holder_required: "Kinakailangan ang pangalan ng may-ari ng bankong account",
  bank_already_setup: "Ang bankong account ay naka-set up na",
  platform_required: "Kinakailangan ang plataporma",
  parent_not_exists: "Parent does not exist",
  parent_id_required: "Parent ID is required",
  password_required: "Kinakailangan ang password",
  contact_phone_required: "Kinakailangan ang numero ng telepono ng kontakto",
  vip_mode_not_exists: "VIP mode does not exist",
  session_not_exists: "Nag-expire na ang iyong sesyon, mangyaring mag-login muli.",
  ticket_id_required: "Kinakailangan ang ID ng tiket",
  ref_id_required: "Kinakailangan ang ID ng sanggunian",
  ticket_not_exists: "Hindi umiiral ang tiket",
  ticket_processed: "Ang tiket ay na-process na",
  min_deposit_not_met: "Ang halaga ng deposito ay dapat hindi bababa sa minimum na halaga",
  ongoing_promotion: "May kasalukuyang promosyon ka. Mangyaring mag-claim ulit mamaya.",
  invalid_promo_package: "Hindi wastong package ng promosyon",
  promo_min_deposit_not_met: "Ang halaga ng deposito ay hindi nakakatugma sa minimum na halaga ng promosyon",
  claim_promo_only_once_a_day: "Ang promosyon ay maaaring i-claim lamang isang beses sa isang araw",
  first_deposit_unmet: "Ang araw-araw na unang gantimpala sa deposito ay na-claim na",
  newbie_unmet: "Ang gantimpalang deposito para sa mga baguhan ay na-claim na",
  claim_promo_only_once: "Ang promosyon ay maaaring i-claim lamang isang beses",
  inner_catch: "Hindi inaasahang error",
  systemError: "Error ng sistema",
  SystemError: "Error ng sistema",
  deposit_amount_required: "Kinakailangan ang halaga ng deposito",
  target_bank_id_required: "Kinakailangan ang target bank ID",
  target_bank_acc_no_required: "Kinakailangan ang numero ng target bank account",
  target_bank_acc_holder_required: "Kinakailangan ang pangalan ng may-ari ng target bank account",
  deposit_date_required: " Kinakailangan ang petsa ng deposito",
  deposit_method_required: "Kinakailangan ang paraan ng deposito",
  min_deposit_not_set: "Hindi pa itinatakda ang minimum na halaga ng deposito",
  min_balance_not_set: "Hindi pa itinatakda ang minimum na available na balanse",
  bank_account_not_exists: "Hindi umiiral ang bankong account",
  bank_account_inactive: "Hindi aktibo ang bankong account",
  withdrawal_amount_required: "Kinakailangan ang halaga ng pagwiwithdraw",
  min_withdrawal_not_set: "Hindi pa itinatakda ang minimum na halaga ng pagwiwithdraw",
  bank_member_not_exists: "Hindi umiiral ang target member bank account",
  promotion_requirement_not_met: "Mayroon ka pang kasalukuyang promosyon",
  invalid_promotion: "Hindi wastong promosyon",
  new_password_required: "Kinakailangan ang bagong password",
  multiplier_not_found: "Hindi kayang i-process ng sistema ang iyong request sa ngayon, subukang muli mamaya",
  contact_phone_exists: "Ang teleponong ito ay may rehistrasyon na",
  BLOCK: "Ang iyong account ay pansamantalang na-suspend",
  tac_expired: "Ang iyong OTP code ay expired na. Mangyaring humiling ng bagong OTP code.",
  tac_not_validate: "Hindi pa naverify ang OTP code",
  exceed_max_withdrawal: "Lumampas sa maximum na halaga ng pagwiwithdraw",
  bank_member_inactive: "Hindi aktibo ang banko ng tagagamit",
  bank_member_exists: "Ang bankong account ay may rehistrasyon na",
  never_deposited : "Dapat kang mag-deposito ng hindi bababa sa isa bago ka makapag-transfer ng pera sa iyong mga kaibigan",
  transferAmountMustGreaterThanEqual5: "Transfer amount must be greater or equal PHP 5",
  invalid_transfer_amount: "Transfer amount must be greater or equal PHP 5",
  // account_not_exists : "account not exists"
  // ongoing_promotion : "You are still having ongoing promotion",
  transfer_success: "Transfer Successfully",
  sender_id_required: "Kinakailangan ang ID ng nagpadala",
  recipient_id_required: "Kinakailangan ang ID ng tatanggap",
  tac_validated: "Na-validate ang OTP code. Mangyaring humiling muli.",
  pending_result_in_game: "May hinihintay pang resulta sa laro",
  accountIdOnlyNumber: "Tanggap lamang ang wastong numero ng telepono",
  unfinishgamedetected: "Mangyaring tapusin muna ang iyong libreng laro bago magpatuloy sa hakbang na ito",
  duplicate_review: "Ipinasa mo na ang iyong pagsusuri dati",
  exceed_withdrawal_frequency: "Lumampas ka na sa araw-araw na limitasyon sa pagwiwithdraw. (5 beses bawat araw)",
  requestTooFrequentAtLeast2Minutes: "Ang iyong request ay kasalukuyang ini-process.",
  invalidPhoneNumberFormat: "Hindi wastong format ng numero ng telepono.",
  fpayUnderMaintenance: "Ang sistema ay nasa ilalim ng pagmamantina.",
  affiliate_not_exists: "Ang affiliate ay hindi umiiral.",
  phoneRequired: 'Mangyaring maglagay ng numero ng telepono.',
  couponeCodeRequired: "Kinakailangan ang code ng kupon.",
  coupon_code_required: "Kinakailangan ang code ng kupon.",
  coupon_not_available: "Hindi magamit ang code ng kupon.",
  contact_email_registered: "Ang email ay mayroon nang umiiral.",
  invalidEmailFormat: "Hindi wastong format ng email.",
  emailRequired: "Kinakailangan ang email.",
  paymentMethodRequired: "Mangyaring pumili ng paraan ng pagbabayad.",
  depositMethodRequired: "Mangyaring pumili ng paraan ng pagdedeposito.",
  resultIdRequired: "Kinakailangan ang ID ng resulta.",
  withdrawal_amount_lte_withhold_amount: "Ang halaga ng pagwiwithdraw ay dapat mababa o pantay sa itinatagal ng halaga.",

  //new
  amount_required: "Kinakailangan ang halaga.",
  auth_token_required: "Kinakailangan ang token ng sesyon.",
  bet_id_required: "Kinakailangan ang ID ng bet.",
  bonus_unavailable: "Hindi magagamit ang bonus.",
  client_ip_required: "Kinakailangan ang IP ng kliyente.",
  first_deposit_not_met: "Kinakailangan ang unang deposito.",
  ftd_required: "Kinakailangan ang unang deposito.",
  game_maintenance: "Kasalukuyang nasa ilalim ng pagmamantina, pakisubukan muli mamaya.",
  gateway_acc_required : "Kinakailangan ang account ng gateway.",
  inbox_id_required: "Kinakailangan ang ID ng inbox.",
  insufficient_rebate: "Kulang na rebate.",
  insufficient_ticket: "Kulang na tiket.",
  is_default_required: "Kinakailangan ang umiiral na pagpili.",
  min_withdrawal_not_met: "Hindi natutugma ang minimum na halaga ng pagwiwithdraw.",
  newbie_not_met: "Hindi natutugma ang newbie.",
  no_changes: "Ang impormasyon ay nananatiling hindi nagbago.",
  promotion_not_available:"Hindi magagamit ang promosyon.",
  ref_no_required: "Kinakailangan ang numero ng sanggunian.",
  result_id_required: "Kinakailangan ang ID ng resulta.",
  search_id_required: "Search ID required",
  setting_not_set: "Setting not configured",
  tac_required: "Kinakailangan ang code ng OTP",
  ticket_count_required: "Kinakailangan ang halaga ng tiket.",
  vip_not_exists: "Hindi ka isang miyembro ng VIP.",
  working_date_required: "Kinakailangan ang petsa ng pagtatrabaho.",
  working_month_required: "Kinakailangan ang buwan ng pagtatrabaho.",
  providerRequired: "Kinakailangan ang nagbibigay ng serbisyo.",
  invalid_contact_email: "Hindi wastong email.",
  invalidUsernameFormat: "Hindi wastong format ng pangalan ng tagagamit.",
  otpRequired: "Kinakailangan ang OTP",
  "Incoming Request Info Incomplete" : "Incoming Request Info Incomplete",
  "Invalid Player": "Invalid Player",
  "Invalid Auth Token" : "Invalid Auth Token",
  "Create Account Failed": "Create Account Failed",
  "Launch Game Failed" : "Launch Game Failed",
  "Invalid Type" : "Invalid Type",
  "Invalid Lang" : "Invalid Lang",
  "System Error" : "System Error"
}